import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './FormDataList.css';

const RFormDataList = () => {
    const [data, setData] = useState([]);

    useEffect(() => {


        fetchData();
    }, [data]);

    const fetchData = async () => {
        const token = localStorage.getItem('token');

        try {
            const response = await axios.get('http://localhost:5000/api/tdata', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setData(response.data);
        } catch (err) {
            console.error('Error fetching data', err);
            console.log(token)
        }
    };

    const handleDelete = async (id) => {
        const token = localStorage.getItem('token');

        try {
            await axios.delete(`http://localhost:5000/api/tdata/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            // Refresh data after deletion
            fetchData();
        } catch (err) {
            console.error('Error deleting data: ' + err.message);
        }
    };
    return (
        <div className="data-container">
            <h2>خاطرات تشییع</h2>
            {data.length === 0 ? (
                <p>محتوایی نیست</p>
            ) : (
                <ul>
                    {data.map((item, index) => (
                        <li key={index}>
                            <p>شماره : {index + 1}</p>
                            <p>نام : {JSON.stringify(item.name)}</p>
                            <p>سن : {JSON.stringify(item.age)}</p>
                            <p>شهر : {JSON.stringify(item.city)}</p>
                            <p>ایمیل : {JSON.stringify(item.email)}</p>
                            <p>تلفن : {JSON.stringify(item.phoneNumber)}</p>
                            <p>سوال : {JSON.stringify(item.question1)}</p>
                            <p>سوال : {JSON.stringify(item.question2)}</p>
                            <p>سوال : {JSON.stringify(item.question3)}</p>
                            <p>id : {JSON.stringify(item._id)}</p>
                            <button onClick={() => handleDelete(item._id)}>حذف</button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default RFormDataList;
